import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { map } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';
import { AdminRole } from '../repository/enums';
import { AdminRoleService } from '../services/admin-role.service';
import { PlatformService } from '../services/platform.service';
import { DIALOG_SERVICE } from './login.guard';

/**
 * 역할 가드
 */
export const roleGuard = (...roleList: AdminRole[]): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const adminRoleService = inject(AdminRoleService);
    const dialogServiceType = inject(DIALOG_SERVICE);
    const dialogService: DialogService = inject(dialogServiceType);
    const platformService = inject(PlatformService);

    // 서버는 무조건 통과
    if (platformService.isPlatformServer) {
      // 시스템 관리자 권한이 아니면 허용
      if (!roleList.includes('ADMIN_SYSTEM')) {
        return true;
      }
      return false;
    }

    if (adminRoleService.isAvail(...roleList)) {
      return true;
    }

    return dialogService.alert('No role').pipe(
      map(() => {
        return router.createUrlTree(['/home']);
      }),
    );
  };
};

/** 서버와 같은 최상위 시스템 관리자 판정으로 접근을 제한한다. */
export const rootSystemAdminGuard: CanActivateFn = () => {
  const router = inject(Router);
  const adminRoleService = inject(AdminRoleService);
  const dialogServiceType = inject(DIALOG_SERVICE);
  const dialogService: DialogService = inject(dialogServiceType);
  const platformService = inject(PlatformService);

  if (platformService.isPlatformServer) {
    return false;
  }

  if (adminRoleService.isRootSystemAdmin()) {
    return true;
  }

  return dialogService.alert('Root system administrator only').pipe(
    map(() => router.createUrlTree(['/home'])),
  );
};
